import { observer } from "mobx-react";
import * as React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";

import ChangePasswordModal from "@client/components/containers/ChangePasswordModal";
import PartnerModal from "@client/components/containers/PartnerModal";
import DropdownNewItem from "@client/components/ui/DropdownNewItem";
import DropdownUser from "@client/components/ui/DropdownUser";
import licensorStore from "@client/stores/LicensorStore";
import Style from "@client/utils/Style";

import CustomerModal from "../CustomerModal";
import LicenceModal from "../LicenceModal";
import LicensorModal from "../LicensorModal";

const Wrapper = styled.div`
  display: flex;
  margin: 48px 0;
  align-items: center;
`;
const Title = styled.div`
  color: ${Style.palette.primary};
  font-size: 32px;
  font-weight: ${Style.fontWeights.light};
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Controls = styled.div`
  display: flex;
  & > div {
    margin-left: 16px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

type Props = {
  title: string;
  onNavigate: (path: string) => void;
  componentRef?: (ref: any) => void;
};
type State = {
  showLicenceModal: boolean;
  showCustomerModal: boolean;
  showUserModal: boolean;
  showPartnerModal: boolean;
  showChangePasswordModal: boolean;
};

@observer
class ListPageHeader extends React.Component<Props, State> {
  state: State = {
    showLicenceModal: false,
    showCustomerModal: false,
    showUserModal: false,
    showPartnerModal: false,
    showChangePasswordModal: licensorStore.hasInitialPassword,
  };

  constructor(props: Props) {
    super(props);

    if (licensorStore.hasInitialPassword) {
      this.state.showChangePasswordModal = true;
    }
    licensorStore.clearHasInitialPassword();

    if (props.componentRef) {
      props.componentRef(this);
    }
  }

  handleNewItem(item: string) {
    switch (item) {
      case "licence":
        this.setState({ showLicenceModal: true });
        break;
      case "customer":
        this.setState({ showCustomerModal: true });
        break;
      case "user":
        this.setState({ showUserModal: true });
        break;
      case "partner":
        this.setState({ showPartnerModal: true });
        break;

      default:
        console.log("new item clicked", item);
    }
  }

  async handleUserItemClick(item: { value: string }) {
    switch (item.value) {
      case "signout":
        await licensorStore.logout();
        this.props.onNavigate("/login");
        break;
      case "changepassword":
        this.setState({ showChangePasswordModal: true });
        break;
      default:
    }
  }

  render() {
    return (
      <Wrapper>
        <Title>{this.props.title}</Title>
        <Controls>
          <DropdownNewItem
            tokenInfo={licensorStore.tokenInfo}
            onChange={item => {
              this.handleNewItem(item);
            }}
          />
          <DropdownUser
            user={licensorStore.tokenInfo?.user}
            onItemClick={item => {
              this.handleUserItemClick(item);
            }}
          />
        </Controls>
        {this.state.showLicenceModal ? (
          <LicenceModal
            onRequestClose={() => {
              this.setState({ showLicenceModal: false });
            }}
          />
        ) : null}
        {this.state.showCustomerModal ? (
          <CustomerModal
            onRequestClose={() => {
              this.setState({ showCustomerModal: false });
            }}
          />
        ) : null}
        {this.state.showUserModal ? (
          <LicensorModal
            onRequestClose={() => {
              this.setState({ showUserModal: false });
            }}
          />
        ) : null}
        {this.state.showPartnerModal ? (
          <PartnerModal
            onRequestClose={() => {
              this.setState({ showPartnerModal: false });
            }}
          />
        ) : null}
        {this.state.showChangePasswordModal ? (
          <ChangePasswordModal
            onRequestClose={() =>
              this.setState({ showChangePasswordModal: false })
            }
          />
        ) : null}
      </Wrapper>
    );
  }
}

function ListPageHeaderWithNavigate(props: Omit<Props, "navigate">) {
  const navigate = useNavigate();
  return <ListPageHeader {...props} onNavigate={navigate} />;
}

export default ListPageHeaderWithNavigate;
